import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export default function ScreeningField({ label, children, help }) {
  return (
    <label style={{ display: 'grid', gap: 6, minWidth: 0 }}>
      <Text strong>{label}</Text>
      {help ? <Text type="secondary">{help}</Text> : null}
      {children}
    </label>
  );
}
